import Vue from "vue";
import { ability } from "@/config/ability";
import { abilitiesPlugin } from "@casl/vue";

Vue.use(abilitiesPlugin, ability);
